export default "__VITE_ASSET__BCVUGmMN__"